import styled from '@emotion/styled';

const PlaylistList = styled('div')({
  position: 'relative',
  width: '100%',
});

export default PlaylistList;
